import { render, staticRenderFns } from "./Selectores.vue?vue&type=template&id=3c9df4b3&scoped=true&"
import script from "./Selectores.vue?vue&type=script&lang=js&"
export * from "./Selectores.vue?vue&type=script&lang=js&"
import style0 from "./Selectores.vue?vue&type=style&index=0&id=3c9df4b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9df4b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VToolbar,
  VToolbarTitle,
})
